import { render, staticRenderFns } from "./kanban-board.vue?vue&type=template&id=dd102e84&"
import script from "./kanban-board.vue?vue&type=script&lang=ts&"
export * from "./kanban-board.vue?vue&type=script&lang=ts&"
import style0 from "./kanban-board.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports